// @flow
'use strict';

import * as React from 'react';

import type { ICofinsSt } from '../../../../types_imposto';

import OpcoesCofinsSt from './opcoes_cofins_st';

type CofinsStProps = {
  item : ICofinsSt,
};

export default function CofinsSt({ item } : CofinsStProps) {
  const opcoesCofinsSt = [];

  Object.keys(item).forEach((i : string) => {
    const Opcao = OpcoesCofinsSt[i.replace('cofins', 'Cofins')];
    if (Opcao)
      opcoesCofinsSt.push(<Opcao key={ i } item={ item[i] }/>);
  });

  return (
      <div id="table-cofins-st">
        <h4>COFINS ST - COFINS Substituição Tributária</h4>
        { opcoesCofinsSt }
      </div>
  );
}
